(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk4-product-story"] && !Shopify.designMode) return;
  try {
    
function pk4MotionInit(){document.querySelectorAll('.pk4-motion').forEach(button=>{if(button.dataset.bound)return;button.dataset.bound='1';let paused=matchMedia('(prefers-reduced-motion: reduce)').matches;function set(){button.setAttribute('aria-pressed',String(paused));button.textContent=paused?button.dataset.play:button.dataset.pause;button.closest('.pk4-story').querySelectorAll('[data-motion]').forEach(img=>{img.src=paused?img.dataset.still:img.dataset.motion;});}button.addEventListener('click',()=>{paused=!paused;set();});if(paused)set();});}pk4MotionInit();document.addEventListener('shopify:section:load',pk4MotionInit);

  } catch(e) { console.error(e); }
})();
})();
